export default __webpack_public_path__ + "static/brcc-before-after-mobile-3c3e3ead1b09d7d4528553ae5d817d2b.webp";